<template>
  <div class="tab-pane fade show active" id="nav-5-3-primary-ver--1" role="tabpanel">
        <!-- Accordion -->
        <span v-on:click="toggleCollapse(collapseStatus)" class="pull-right" style=""><a class="g-font-size-12" v-if="collapseStatus == false">Expand All </a><a class="g-font-size-12" v-if="collapseStatus == true">Collapse All</a></span>
        <h3 class="g-color-main">Order</h3>
        <div style="background-color: #26304d; height: 3px; margin-bottom: 10px"></div>
        <div v-for="(group, index) in groups" id="accordion-12-1" class="u-accordion u-accordion-color-primary" role="tablist" aria-multiselectable="true">
            <!-- Card -->
            <div class="card g-brd-none rounded-0" :class="{'g-bg-secondary': ((index % 2) == 1)}">
            <div id="accordion-12-1-heading-01" class="u-accordion__header g-color-text g-font-weight-500" role="tab">
                <h5 class="mb-0">
                <a v-on:click="changeCollapse(group)" class="d-block g-color-text g-font-size-20--md g-font-size-17 g-color-primary--hover g-text-underline--none--hover g-pa-12"  data-toggle="collapse" data-parent="#accordion-12-1" aria-expanded="true" aria-controls="accordion-12-1-body-01">
                    {{group.name}}
                </a>
                </h5>
            </div>
            <div v-show="group.open" id="accordion-12-1-body-01" class="collapsed show" role="tabpanel" aria-labelledby="accordion-12-1-heading-01">
                <div class="u-accordion__body g-color-text g-pa-30 g-pt-0">
                <span class="g-font-size-20--md g-font-size-17" v-html="group.items"></span> 
                </div>
            </div>
            </div>
            <!-- End Card -->
        </div>
        <!-- End Accordion -->
    </div>
</template>
<script>
export default {
    data () {
    return {
        collapseStatus: false,
        groups: [
            {
                "name": "Can I add/affiliate new eye doctors to my account?",
                "open": false,
                "items": "Yes, you may add eye doctors by going to <a href='UserAccount'>My Account</a> and selecting Edit to add doctors who will be conducting charity exams for your Business or Non-Profit. Additionally, you may add the eye doctor on the Order page at the time of the order, and identify if the eye doctor should be added only to this order, or to your account for this and future orders."
            },
            {
                "name": "Why are you capturing demographic information on the order?",
                "open": false,
                "items": "We are requesting limited data (gender and ethnicity) in order to assess regional trends and be able to customize resources or programs based on the anticipated need. The data fields are not required, but will be helpful in delivery of services and program enhancements. In proceeding with the registration process, you were asked to complete a Business Associate Agreement (BAA) which allows for the capture of a limited data set for program operations. If you wish to review the BAA, you may view it on the <a href='UserAccount'>My Account</a> page under Communication Preferences."
            },
            {
                "name": "What if my patient requires a lens that is not offered on the Order page?",
                "open": false,
                "items": "If a patient has a medically necessary prescription requirement, please indicate the Special Request by checking the box that says “The lens options above do not meet the medical needs of this patient” on the Order page. The order will be submitted to Essilor Vision Foundation for review and approval. Including a Special Request may increase the time for production."
            },
            {
                "name": "Can I order glasses with prism or OC height?",
                "open": false,
                "items": "Yes, to order glasses with prism or OC height just check the 'Additional Rx Fields' checkbox."
            },
            {
                "name": "What does the “Exam only” check box mean?",
                "open": false,
                "items": "This selection on the Order page allows you to indicate any patients who have received exams and are not issued a prescription. This will allow you the opportunity to track total number of patients who have received vision services. These exam entries will be displayed on the Track Order page and should the need arise to convert this exam into an order you can View the entry and select the “Convert to Order” button on the Order Confirmation page. This will open an Order form populated with the exam information to add a prescription and Submit to the lab."
            },
            {
                "name": "What does the “Remake/Redo” check box mean?",
                "open": false,
                "items": "This check box will be automatically selected if you choose the “Remake/Redo” option on the Order Confirmation of an order that was received with an error. This is only to be used in remaking an existing order submitted through Changing Life through Lenses™"
            },
            {
                "name": "What does the “International Mission” check box mean?",
                "open": false,
                "items": "This selection should be used for those who are supporting a one-time International vision clinic. Essilor Vision Foundation supports one-time International mission aid for US-based doctors and non-profits. We simply ask you indicate the order is for an International patient, so that we can have accurate recordkeeping of the services rendered. It is not for use for any ongoing sustainable clinics outside the United States."
            },
            {
                "name": "What is the Order Reference/P.O. field?",
                "open": false,
                "items": "This is a free-entry text field to allow you to put a reference name/number (i.e.: Washington Elem., Student ID: 12345) to track or organize your orders. This optional field will be printed on the Order Summary and on the completed order when it returns from the lab "
            }
        ]
    }
    },
    methods: {
        toggleCollapse(collapseStatus) {
            this.collapseStatus = !this.collapseStatus;
            this.groups.forEach(element => {
                element.open = this.collapseStatus;
            });
        },
        changeCollapse(group) {
            this.groups.forEach(element => {
                element.open = false;
            });
            group.open = true;
        },
        RouterRedirect(name){
        this.$router.push({name: name});
    }
    }
}
</script>



// WEBPACK FOOTER //
// Order.vue?638c57d3